export enum DeliveryModeEnum {
    FULLY_AUTONOMOUS = 'Fully Autonomous',
    SEMI_AUTONOMOUS = 'Semi Autonomous',
}